import { useNavigate } from "react-router-dom";
import "./style.scss";
import React from "react";

interface IProps {
  isHiddenButtonBack?: boolean;
  disableBack?: boolean;
  setVisible?: React.Dispatch<React.SetStateAction<boolean>>;
  double?: boolean;
  onBack?: () => void;
}

const BackToPage = (props: IProps) => {
  const { setVisible, disableBack, double, onBack } = props;
  const navigate = useNavigate();
  const handleClick = () => {
    if (onBack) {
      onBack();
      return;
    }
    if (double) {
      navigate(-2);
      return;
    }
    if (!disableBack) {
      navigate(-1);
    } else {
      setVisible?.(false);
    }
  };
  return (
    <div className="wrap-back-to-page">
      <div
        onClick={handleClick}
        className="icon cursor-pointer"
        style={props.isHiddenButtonBack ? { display: "none" } : {}}
      >
        ＜ 戻る
      </div>
    </div>
  );
};

export default BackToPage;
